export default __webpack_public_path__ + "static/OpenSansBold-64de30efd73e190ae07b5a9b1bda4002.eot";